import React from 'react';

const ChatTabIcon = ({
  className = '',
  state = 'not-selected', // 'not-selected', 'hover', 'selected'
  config, // Add config prop for dynamic styling
  ...props
}) => {
  const getStrokeColor = () => {
    // Use dynamic color from config if available, otherwise fallback to CSS classes
    if (config?.element_color) {
      switch (state) {
        case 'selected':
        case 'hover':
          return config.element_color;
        case 'not-selected':
        default:
          return `${config.element_color}80`; // 50% opacity for inactive state
      }
    }

    // Fallback to CSS classes when no config is provided
    switch (state) {
      case 'selected':
        return 'text-v3-black-heading';
      case 'hover':
        return 'text-v3-black-heading';
      case 'not-selected':
      default:
        return 'text-v3-black-secondary';
    }
  };

  const getIconSize = () => {
    return state === 'selected' ? { width: 25, height: 24 } : { width: 24, height: 24 };
  };

  const { width, height } = getIconSize();
  const strokeColor = getStrokeColor();

  if (state === 'selected') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 25 24"
        fill="none"
        className={config?.element_color ? className : `${strokeColor} ${className}`}
        style={config?.element_color ? { color: strokeColor } : undefined}
        {...props}
      >
        <g clipPath="url(#clip0_2135_4131)">
          <path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="M12.5 22C18.023 22 22.5 17.523 22.5 12C22.5 6.477 18.023 2 12.5 2C6.977 2 2.5 6.477 2.5 12C2.5 13.6 2.876 15.112 3.543 16.453C3.721 16.809 3.78 17.216 3.677 17.601L3.082 19.827C3.02307 20.0473 3.02312 20.2792 3.08216 20.4995C3.14119 20.7197 3.25712 20.9206 3.41831 21.0819C3.57951 21.2432 3.7803 21.3593 4.00053 21.4184C4.22075 21.4776 4.45267 21.4778 4.673 21.419L6.899 20.823C7.28538 20.7254 7.69414 20.7727 8.048 20.956C9.43095 21.6446 10.9551 22.002 12.5 22ZM8.5 13.25C8.30109 13.25 8.11032 13.329 7.96967 13.4697C7.82902 13.6103 7.75 13.8011 7.75 14C7.75 14.1989 7.82902 14.3897 7.96967 14.5303C8.11032 14.671 8.30109 14.75 8.5 14.75H14C14.1989 14.75 14.3897 14.671 14.5303 14.5303C14.671 14.3897 14.75 14.1989 14.75 14C14.75 13.8011 14.671 13.6103 14.5303 13.4697C14.3897 13.329 14.1989 13.25 14 13.25H8.5ZM7.75 10.5C7.75 10.3011 7.82902 10.1103 7.96967 9.96967C8.11032 9.82902 8.30109 9.75 8.5 9.75H16.5C16.6989 9.75 16.8897 9.82902 17.0303 9.96967C17.171 10.1103 17.25 10.3011 17.25 10.5C17.25 10.6989 17.171 10.8897 17.0303 11.0303C16.8897 11.171 16.6989 11.25 16.5 11.25H8.5C8.30109 11.25 8.11032 11.171 7.96967 11.0303C7.82902 10.8897 7.75 10.6989 7.75 10.5Z" 
            fill="currentColor"
          />
          <circle cx="20.5" cy="4" r="4" fill="#DC2626"/>
        </g>
        <defs>
          <clipPath id="clip0_2135_4131">
            <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
          </clipPath>
        </defs>
      </svg>
    );
  }

  if (state === 'hover') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 25 24"
        fill="none"
        className={config?.element_color ? className : `${strokeColor} ${className}`}
        style={config?.element_color ? { color: strokeColor } : undefined}
        {...props}
      >
        <path 
          d="M12.5 22C18.023 22 22.5 17.523 22.5 12C22.5 6.477 18.023 2 12.5 2C6.977 2 2.5 6.477 2.5 12C2.5 13.6 2.876 15.112 3.543 16.453C3.721 16.809 3.78 17.216 3.677 17.601L3.082 19.827C3.02307 20.0473 3.02312 20.2792 3.08216 20.4995C3.14119 20.7197 3.25712 20.9206 3.41831 21.0819C3.57951 21.2432 3.7803 21.3593 4.00053 21.4184C4.22075 21.4776 4.45267 21.4778 4.673 21.419L6.899 20.823C7.28538 20.7254 7.69414 20.7727 8.048 20.956C9.43095 21.6446 10.9551 22.002 12.5 22Z" 
          stroke="currentColor" 
          strokeWidth="1.5"
        />
        <path 
          d="M8.5 10.5H16.5M8.5 14H14" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          strokeLinecap="round"
        />
        <circle cx="20.5" cy="4" r="4" fill="#DC2626"/>
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={config?.element_color ? className : `${strokeColor} ${className}`}
      style={config?.element_color ? { color: strokeColor } : undefined}
      {...props}
    >
      <path 
        d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 13.6 2.376 15.112 3.043 16.453C3.221 16.809 3.28 17.216 3.177 17.601L2.582 19.827C2.52307 20.0473 2.52312 20.2792 2.58216 20.4995C2.64119 20.7197 2.75712 20.9206 2.91831 21.0819C3.07951 21.2432 3.2803 21.3593 3.50053 21.4184C3.72075 21.4776 3.95267 21.4778 4.173 21.419L6.399 20.823C6.78538 20.7254 7.19414 20.7727 7.548 20.956C8.93095 21.6446 10.4551 22.002 12 22Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M8 10.5H16M8 14H13.5" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
      <circle cx="20" cy="4" r="4" fill="#DC2626"/>
    </svg>
  );
};

export default ChatTabIcon;
